import * as React from 'react'

const SvgBuilding = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={140}
    height={120}
    viewBox="0 0 140 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Building_svg__a)">
      <path d="M117.176 26.26H18.567v93.735h98.609V26.26Z" fill="#fff" />
      <path d="M18.469 26.26H.054v93.735H18.47V26.26Z" fill="#E1CEFF" />
      <path
        d="M66.111 2.459a.994.994 0 1 1 0-1.99.994.994 0 1 1 0 1.99Z"
        fill="#fff"
      />
      <path
        d="M117.191 26.26H9.821L18.469.04h79.784c5.513 0 10.448 3.42 12.366 8.569l6.577 17.65h-.005Z"
        fill="#C4B1FA"
      />
      <path
        d="M66.8 32.37h1.73c3.343 0 6.052 2.706 6.052 6.032v14.921H60.747V38.402c0-3.331 2.715-6.032 6.052-6.032ZM66.8 61.779h1.73c3.343 0 6.052 2.705 6.052 6.032v14.92H60.747v-14.92c0-3.332 2.715-6.032 6.052-6.032ZM66.433 91.192h2.457c4.747 0 8.604 3.844 8.604 8.575V120H57.83V99.767c0-4.73 3.857-8.575 8.604-8.575ZM96.353 32.37h1.73c3.343 0 6.053 2.706 6.053 6.032v14.921H90.301V38.402c0-3.331 2.714-6.032 6.052-6.032ZM96.353 61.779h1.73c3.343 0 6.053 2.705 6.053 6.032v14.92H90.301v-14.92c0-3.332 2.714-6.032 6.052-6.032ZM96.353 91.192h1.73c3.343 0 6.053 2.706 6.053 6.032v14.921H90.301V97.224c0-3.331 2.714-6.032 6.052-6.032ZM37.243 32.37h1.731c3.343 0 6.053 2.706 6.053 6.032v14.92H31.19v-14.92c0-3.331 2.715-6.032 6.052-6.032ZM37.243 61.779h1.731c3.343 0 6.053 2.705 6.053 6.032v14.92H31.19v-14.92c0-3.332 2.715-6.032 6.052-6.032ZM37.243 91.192h1.731c3.343 0 6.053 2.706 6.053 6.032v14.921H31.19V97.224c0-3.331 2.715-6.032 6.052-6.032ZM18.568 26.26V0A12.651 12.651 0 0 0 6.705 8.224L0 26.26h18.568Z"
        fill="#7130C9"
      />
      <path
        d="M138.141 105.384c-2.235-1.725-4.237-3.922-6.611-5.445-2.279-1.508-4.91-2.405-7.64-3.174 2.572-2.76 7.121-2.665 10.152-.64 3.006 1.966 4.792 5.716 4.099 9.259ZM121.527 96.332c-1.024-2.627-1.607-5.539-2.853-8.062-1.177-2.464-2.962-4.578-4.91-6.642 3.629-1.045 7.481 1.37 9.034 4.661 1.557 3.228 1.152 7.357-1.271 10.038v.005Z"
        fill="#C4B1FA"
      />
      <path
        d="M140 92.291c-1.113-.128-2.111-.34-3.194-.468-1.845-.212-3.694-.158-5.454.384-2.75.789-5.598 2.587-8.283 3.874.396-4.86 5.113-8.94 10.087-8.59 2.962.207 5.731 2.046 6.844 4.8ZM127.545 110.74c-1.316-1.976-2.107-3.952-2.942-6.11a49.092 49.092 0 0 1-1.85-6.12c-.079-.34-.158-.675-.237-1.07.781 0 1.483.247 2.166.553 1.29.63 2.358 1.63 3.14 2.818 1.933 2.932 2.131 7.2-.277 9.925v.004ZM120.785 96.81c-2.339-.434-4.312-1.252-6.448-2.159a49.127 49.127 0 0 1-5.692-2.946c-.296-.183-.598-.36-.934-.577.539-.557 1.206-.887 1.909-1.163 1.354-.483 2.818-.547 4.217-.276 3.457.66 6.666 3.499 6.948 7.12Z"
        fill="#C4B1FA"
      />
      <path
        d="M112.933 119.995h10.483s-9.168-8.924-1.158-23.116c0 0-15.096 7.209-9.325 23.116Z"
        fill="#AC94F0"
      />
    </g>
    <defs>
      <clipPath id="Building_svg__a">
        <path fill="#fff" d="M0 0h140v120H0z" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgBuilding
